import { useNavigate } from "react-router-dom";
import { MobileFrame } from "@/components/MobileFrame";
import { Icon } from "@/components/primitives";

export default function Terms() {
  const nav = useNavigate();
  return (
    <MobileFrame>
      <div style={{
        padding: "12px 20px 0",
        display: "flex", justifyContent: "space-between", alignItems: "center",
      }}>
        <button
          onClick={() => nav(-1)}
          aria-label="Back"
          style={{ background: "none", border: "none", padding: 6, cursor: "pointer", color: "hsl(var(--ink))" }}
        >
          {Icon.chev(18, "l")}
        </button>
        <span className="caps">Terms</span>
        <div style={{ width: 30 }} />
      </div>
      <div style={{ padding: "16px 20px", lineHeight: 1.5 }}>
        <h1>Terms of Service</h1>
        <p>By creating an account or using FIG, you agree to these terms and to our <a href="/community-guidelines">Community Guidelines</a> and <a href="/privacy">Privacy Policy</a>.</p>

        <h2>Account</h2>
        <p>You must be 13 or older. You're responsible for activity on your account and for keeping your sign-in credentials secure.</p>

        <h2>Content</h2>
        <p>You retain ownership of your photos and posts. You grant FIG a non-exclusive license to display them in the app. You're responsible for any content you upload.</p>

        <h2>Verification</h2>
        <p>FIG provides authentication assessments. Verifications reflect FIG's best assessment and are not guarantees. FIG is not liable for transactions between users.</p>

        <h2>Payments</h2>
        <p>Payments are processed by Stripe. FIG is not a party to transactions between buyers and sellers.</p>

        <h2>Termination</h2>
        <p>FIG may suspend or terminate accounts that violate these terms. You may delete your account at any time in Settings.</p>

        <h2>Limitation of liability</h2>
        <p>FIG is provided "as is." To the maximum extent permitted by law, FIG and its operators are not liable for indirect, incidental, or consequential damages.</p>

        <h2>Contact</h2>
        <p>support@figverified.com</p>
      </div>
    </MobileFrame>
  );
}
